import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { api } from "@/lib/api";
import { Users, ShieldCheck, Link2 } from "lucide-react";

/** Safe aggregate participation stats — hidden until the admin threshold is met at this level. */
export const WitnessStatsCard = ({ municipalityId = null, electionId = null, title = "WitnessYourVote Participation" }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const params = {};
    if (municipalityId) params.municipality_id = municipalityId;
    if (electionId) params.election_id = electionId;
    api.get("/public/witness-stats", { params }).then((r) => setStats(r.data)).catch(() => {});
  }, [municipalityId, electionId]);

  if (!stats || !stats.available) return null;

  return (
    <Card data-testid="witness-stats-card">
      <CardContent className="p-6">
        <h2 className="font-heading font-semibold text-base text-foreground mb-4">{title}</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
          <div className="rounded-lg bg-slate-50 border border-slate-200 p-3">
            <Users className="h-4 w-4 text-accent mx-auto mb-1" />
            <p className="font-heading font-bold text-xl tabular-nums" data-testid="stats-total">{stats.total_declarations.toLocaleString()}</p>
            <p className="text-[11px] text-muted-foreground">Declarations</p>
          </div>
          <div className="rounded-lg bg-slate-50 border border-slate-200 p-3">
            <ShieldCheck className="h-4 w-4 text-accent mx-auto mb-1" />
            <p className="font-heading font-bold text-xl tabular-nums" data-testid="stats-witnessed">{stats.witnessed.toLocaleString()}</p>
            <p className="text-[11px] text-muted-foreground">Witnessed</p>
          </div>
          <div className="rounded-lg bg-slate-50 border border-slate-200 p-3">
            <Link2 className="h-4 w-4 text-accent mx-auto mb-1" />
            <p className="font-heading font-bold text-xl tabular-nums" data-testid="stats-mutual">{stats.mutually_witnessed.toLocaleString()}</p>
            <p className="text-[11px] text-muted-foreground">Mutually witnessed</p>
          </div>
          <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-3">
            <p className="font-heading font-bold text-xl tabular-nums text-emerald-800" data-testid="stats-coverage">{stats.witness_coverage_percent}%</p>
            <p className="text-[11px] text-emerald-800">Witness coverage</p>
          </div>
        </div>
        {stats.wards?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-4">
            {stats.wards.map((w) => (
              <Badge key={w.ward} variant="outline" className="text-[10px]">
                {w.ward}: {w.witnessed}/{w.total} witnessed
              </Badge>
            ))}
          </div>
        )}
        <p className="text-[11px] text-muted-foreground mt-4" data-testid="stats-label">{stats.label}</p>
      </CardContent>
    </Card>
  );
};
